export function isAuthError(errors: any[]): boolean {
    return !!(
        errors &&
        errors.length &&
        errors.some(e => e.extensions?.code === 'AUTH_ERROR')
    );
}

export const dontRefreshTokenCookieName = 'dontRefreshToken';
